// @flow

import {
  filesDownloadStart,
  filesDownloadComplete,
  filesDownloadReset,
} from 'docs/data/integration-builder/file/FileDownloadReducer';
import type {Dispatcher} from 'docs/data';
import type {FileContent} from 'docs/data/integration-builder';
import type {FileDownloadEvent} from 'docs/data/integration-builder/file/FileDownloadReducer';
import JSZip from 'jszip';

const applyLinkStyles = (
  link: HTMLAnchorElement,
  position: $PropertyType<CSSStyleDeclaration, 'position'>,
  left: $PropertyType<CSSStyleDeclaration, 'left'>,
  top: $PropertyType<CSSStyleDeclaration, 'top'>,
) => {
  link.style.position = position;
  link.style.left = left;
  link.style.top = top;
};

export const generateLink = async (files: FileContent) => {
  const zip = new JSZip();
  const link = document.createElement('a');
  applyLinkStyles(link, 'absolute', '-1000px', '-1000px');

  for (const name of Object.keys(files)) {
    zip.file(name, files[name]);
  }

  const content = await zip.generateAsync({type: 'base64'});
  link.href = `data:application/zip;base64,${content}`;
  link.download = `stripe-sample-code.zip`;
  return link;
};

export const downloadFiles = (
  dispatch: Dispatcher<FileDownloadEvent>,
) => async (files: FileContent) => {
  dispatch(filesDownloadStart());
  try {
    let error = null;
    let success = true;
    const link = await generateLink(files);
    if (document.body) {
      document.body.appendChild(link);
      link.click();

      // Make Flow happy
      if (document.body) {
        document.body.removeChild(link);
      }
    } else {
      success = false;
      error = 'document.body not available';
    }
    dispatch(filesDownloadComplete(success, error));
  } catch (e) {
    dispatch(filesDownloadComplete(false, 'error'));
  }

  setTimeout(() => {
    dispatch(filesDownloadReset());
  }, 1500);
};
